/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2018 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import { observable, action } from "mobx";
import { lhpFeatures } from "constants/enums";
import { AttachmentsModel } from "./AttachmentsModel";
import { isBoolean } from "utils/lodashUtils";
import { trackOnLHPFeatureUpdate } from "analytics/events";

class LHPStore {
  @observable showLHP;
  @observable showUndoButton;
  @observable showRedoButton;
  @observable currLHPFeature;
  @observable attachmentsModel;
  attachmentsInitializeOpts = {};

  constructor() {
    this.init();
  }

  initStore(docApi, stores) {
    if (docApi) {
      this.docApi = docApi;
    }
    if (stores) {
      this.stores = stores;
    }
  }

  @action
  init() {
    this.showLHP = true;
    this.showUndoButton = true;
    this.showRedoButton = true;
    this.currLHPFeature = lhpFeatures.NONE;
    this.isExplicitlyDisabled = false;
    this.attachmentsModel = new AttachmentsModel();
  }

  @action
  setLHPVisibility(visible) {
    if (isBoolean(visible)) {
      this.showLHP = visible;
    }
  }

  @action
  setUndoButtonVisibility(visible) {
    if (isBoolean(visible)) {
      this.showUndoButton = visible;
    }
  }

  @action
  setRedoButtonVisibility(visible) {
    if (isBoolean(visible)) {
      this.showRedoButton = visible;
    }
  }

  @action
  setCurrLHPFeature(lhpFeature) {
    trackOnLHPFeatureUpdate(this.currLHPFeature, lhpFeature);
    this.currLHPFeature = lhpFeature;
  }

  getLHPExplicitlyDisabled() {
    return this.isExplicitlyDisabled;
  }

  @action.bound
  setLHPExplicitlyDisabled(value) {
    this.isExplicitlyDisabled = value;
  }

  setAttachmentsInitializeOpts(opts) {
    this.attachmentsInitializeOpts = opts;
  }
}

export { LHPStore };
